'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { Input } from '@/shared/ui/input/input';
import baseIcons from '@/shared/assets/sprites/base.sprite.svg';
interface SearchSectionProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onSearchFocus: () => void;
}
export const SearchSection: React.FC<SearchSectionProps> = ({
  searchQuery,
  onSearchFocus,
  onSearchChange
}) => {
  const t = useTranslations('shared.header.cityModal');
  return <div data-sentry-component="SearchSection" data-sentry-source-file="SearchSection.tsx">
      <Input type="text" value={searchQuery} onChange={e => onSearchChange(e.target.value)} onFocus={onSearchFocus} placeholder={t('search')} variant="leftIcon" className="w-full font-normal md:w-96" data-sentry-element="Input" data-sentry-source-file="SearchSection.tsx">
        <div className="absolute left-5 top-1/2 -translate-y-1/2">
          <svg className="size-6 text-gray-400" data-sentry-element="svg" data-sentry-source-file="SearchSection.tsx">
            <use xlinkHref={`${baseIcons}#search`} data-sentry-element="use" data-sentry-source-file="SearchSection.tsx" />
          </svg>
        </div>
      </Input>
    </div>;
};